import { useQuery } from "react-query";
import { getHrBusPartnerEmployees } from "../../../../../actions/Employees";

const useGetHrBusPartnerEmployees = () => {
  return useQuery("GetHrBusPartnerEmployees", getHrBusPartnerEmployees, {
    refetchOnWindowFocus: false,
  });
};

export default useGetHrBusPartnerEmployees;
